<template>
  <div>
    <PendingCasesView></PendingCasesView>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
const PendingCasesView = defineAsyncComponent(() =>
  import("@/components/pendingCases/PendingCasesView")
);
export default {
  components: {
    PendingCasesView,
  },
};
</script>
